/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import * as References from './UserProgressBFFChirpService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.userprogress.bff.rpc.UserProgressBFFChirpService#getUserProgress
 */
export const GET_USER_PROGRESS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: 'getUserProgress',
  args: ['requestedProgress', 'includePlaylistRemainingDuration'],
  fetcher(request) {
    return chirpClient.call(References.getUserProgressRpc, {
      request
    });
  }
});